/**
 * Editing state of an employee event (shift/absence entry).
 *
 * Moved here from `_modules/employee-panel/dashboard-calendar-v2/x-models/enums/state.ts` when the two
 * unreachable `employee-panel` dashboard components were deleted under Bug #234. It had to move rather than go
 * with them: the enum is consumed by live code (`_modules/employee-panel/_services/event.service.ts`,
 * `models/event/employee-event.ts`, `models/event/employee-event-response-nl.ts`), so leaving it behind would
 * have stranded it in a directory named after a component that no longer exists.
 *
 * `src/app/enums/` is the established home for app-wide enums (see `alert-level.ts`, `routes.ts`). The exported
 * name stays `State` so the move is import-path-only and changes no behaviour.
 */
export enum State {
  New = 0,
  Edit = 1,
  Locked = 2,
}
